import { Chip, CircularProgress, Grid, Table, TableBody, TableCell, TableHead, TableRow, Typography, tableCellClasses } from '@mui/material';
import { FC, useEffect, useState } from 'react';

import Box from '@mui/material/Box';
import { useAppDispatch, useAppSelector } from "../../store/hooks";

import { fetchInvoices } from '../../store/invoiceStore/invoiceThunk';
import { fetchReport, fetchPartyLedgerReport, downloadPartyLedgerReport } from '../../store/reportStore/reportThunk';

import styled_ from "@emotion/styled";
import LoadingButton from '@mui/lab/LoadingButton';
import moment from 'moment';
import { ApiStatus } from "../../utils/api.types";
import { Utils, VocuherCategory } from "../../utils/common-utils";
import Filters from '../Filters/Filters';
import generatePDF, { Resolution, Margin, Options } from "react-to-pdf";
import { Italic } from 'lucide-react';
import { toast } from 'react-toastify'
import DownloadForOfflineOutlinedIcon from '@mui/icons-material/DownloadForOfflineOutlined';
import ReusableReportHeader from './ReusableReportHeader';


const StyledTableCell = styled_(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#eaecf0',
    color: '#000',
    border: '0.75px solid #d9d4d4',
    margin: 0,
    padding: 5,
    fontSize: '9pt',
    paddingLeft: '15px !important',
    fontWeight: 600,
  },
  [`&.${tableCellClasses.footer}`]: {
    backgroundColor: '#f5f5f5',
    color: 'black',
    borderTop: '0.25px solid #d9d4d4',
    borderBottom: '0.25px solid #d9d4d4',
    left: 0,
    bottom: 0, // <-- KEY
    zIndex: 2,
    position: 'sticky'
  },
  [`&.${tableCellClasses.body}`]: {
    verticalAlign: 'super',
    fontSize: '9pt',
    fontWeight: 'normal',
    color: '#292d35',
    padding: 5,
    border: '0.75px solid #d9d4d4',
    paddingLeft: '15px !important',
    margin: 0,
    backgroundColor: '#fff',
  },
}));

const StyledTableRow = styled_(TableRow)(({ theme }) => ({
  // hide last border
  '&:last-child td, &:last-child th': {
  },
}));


interface PartyReportDataProps {
  type: string;
}
const PartyLedgerReport: FC<PartyReportDataProps> = (props) => {
  const dispatch = useAppDispatch();
  // const { invoices, status } = useAppSelector(state => state.invoices);
  const { reportsData, status } = useAppSelector(state => state.reports);
  const [ledgerReport, setLedgerReport] = useState<any>({});
  const { permissions, selectedAccount } = useAppSelector(state => state.auth);
  const [filters, setFilters] = useState('');
  const [filterData, setFilterData] = useState<any>();
  const [isLoading, setIsLoading] = useState(true);

  const filterOnChangeHandler = (data: any) => {
    setFilters(data);
  };
  const filterdOnChangeHandler = (data: any) => {
    setFilterData(data);
  };

  const handleDownloadReport = async () => {
    const { _id: id } = selectedAccount;
    setIsLoading(true);

    dispatch(downloadPartyLedgerReport({ accountId: id, type: VocuherCategory.SALE, isDownloadPdf: 'true', params: filters })).unwrap().then((data) => {
      if (data) {
        // Create a Blob from the response data
        const blob = new Blob([data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);

        console.log(url);
        

        // Create a link element, set the href, and trigger the download
        const a = document.createElement("a");
        a.href = url;
        a.download = "ledger_report.pdf";
        document.body.appendChild(a);
        a.click();

        // Cleanup
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        toast.success("Download completed");
      }
    });
    setIsLoading(false);
  };

  useEffect(() => {
    const { _id: id } = selectedAccount;
    if (filters) {
      setIsLoading(true);
      dispatch(fetchPartyLedgerReport({ accountId: id, type: VocuherCategory.SALE, params: filters })).unwrap().then((data) => {
        if (data) {
          setLedgerReport(data);
          setIsLoading(false);
        }
      });
      // dispatch(fetchPartyLedgerReport({ accountId: id, type: VocuherCategory.SALE, params: filters }));
    }

  }, [dispatch, selectedAccount, filters]);


  const options: Options = {
    filename: `ledger_report_${Date.now()}.pdf`,
    method: "save",
    // default is Resolution.MEDIUM = 3, which should be enough, higher values
    // increases the image quality but also the size of the PDF, so be careful
    // using values higher than 10 when having multiple pages generated, it
    // might cause the page to crash or hang.
    resolution: Resolution.NORMAL,
    page: {
      // margin is in MM, default is Margin.NONE = 0
      margin: Margin.MEDIUM,
      // default is 'A4'
      format: "A4",
      // default is 'portrait'
      // orientation: "landscape"
    },
    canvas: {
      // default is 'image/jpeg' for better size performance
      mimeType: "image/jpeg",
      qualityRatio: 1
    },
    // Customize any value passed to the jsPDF instance and html2canvas
    // function. You probably will not need this and things can break,
    // so use with caution.
    overrides: {
      // see https://artskydj.github.io/jsPDF/docs/jsPDF.html for more options
      pdf: {
        compress: true
      },
      // see https://html2canvas.hertzen.com/configuration for more options
      canvas: {
        useCORS: true
      }
    }
  };

  // you can also use a function to return the target element besides using React refs
  const getTargetElement = () => document.getElementById("pdfContainer");

  const downloadPdf = () => generatePDF(getTargetElement, options);



  return (
    <>
      {/* <Grid container spacing={2} p={0.5} mb={1} pt={9}>
        Need this container to keep show filter on screen
      </Grid> */}

      <Grid container spacing={2} >
        <Grid item xs={12}>
          <Box sx={{ width: 'calc(100% - 7px)', height: 'calc(100vh - 70px)', display: 'flex', flexDirection: 'column', overflow: 'hidden', mb: 2 }} className={'c-card2'}>
            {/* Scrollable content area */}
            <Box sx={{
              flex: 1,
              overflow: 'auto',
              minHeight: 0,
              '&::-webkit-scrollbar': { display: 'none' },
              msOverflowStyle: 'none',
              scrollbarWidth: 'none'
            }}>
              {/* Report Header */}
              <ReusableReportHeader
                reportType="PARTY_LEDGER"
                title="Party Ledger"
                subtitle={(filterData && filterData.periodString) ? filterData.periodString : ''}
                recordCount={ledgerReport?.ledgers?.length || 0}
                isLoading={isLoading}
                onDownloadPDF={handleDownloadReport}
                showPrint={false}
                showShare={false}
              />

              {/* Filters and Summary Section */}
              <Grid container px={2} py={1.5}>
                <Grid xs={6}>
                  <Filters type={VocuherCategory.SALE} filterHandler={filterOnChangeHandler} selectedFilters={filterdOnChangeHandler} hideFilter={true} />
                </Grid>

                {/* Right side summary section */}
                <Grid xs={6} style={{ textAlign: 'right', paddingLeft: '16px' }}>
                  {(ledgerReport.ledgerSummary && filterData && filterData.selectedClient) &&
                   <Typography style={{fontSize: 14, fontWeight: 400, marginBottom: '8px'}}>
                     <strong style={{paddingRight: 10}}>Party:</strong>{filterData.selectedClient.name}
                   </Typography>
                  }
                  <Typography style={{
                    fontSize: 14,
                    fontWeight: 400,
                    marginBottom: '6px',
                    color: ledgerReport.ledgerSummary?.netBalance >= 0 ? '#2e7d32' : '#d32f2f'
                  }}>
                    <strong style={{paddingRight: 10}}>Net Balance:</strong>
                    {Utils.formatNumber(parseFloat(ledgerReport.ledgerSummary?.netBalance || 0).toFixed(2))}
                  </Typography>
                  {ledgerReport.ledgerSummary?.outstandingReceivables > 0 && (
                    <Typography style={{fontSize: 14, fontWeight: 400, marginBottom: '6px'}}>
                      <strong style={{paddingRight: 10}}>Outstanding Receivables:</strong>
                      {Utils.formatNumber(parseFloat(ledgerReport.ledgerSummary.outstandingReceivables).toFixed(2))}
                    </Typography>
                  )}
                  {ledgerReport.ledgerSummary?.outstandingPayables > 0 && (
                    <Typography style={{fontSize: 14, fontWeight: 400, marginBottom: '6px'}}>
                      <strong style={{paddingRight: 10}}>Outstanding Payables:</strong>
                      {Utils.formatNumber(parseFloat(ledgerReport.ledgerSummary.outstandingPayables).toFixed(2))}
                    </Typography>
                  )}
                </Grid>
              </Grid>

              {!isLoading ?
              <>
              <div id='pdfContainer'>
                <Table sx={{ minWidth: 700, tableLayout: 'fixed', width: '100%' }} size='small' aria-label="customized table">
                <colgroup>
                  <col style={{ width: '10%' }} />
                  <col style={{ width: '15%' }} />
                  <col style={{ width: '20%' }} />
                  <col style={{ width: '15%' }} />
                  <col style={{ width: '15%' }} />
                  <col style={{ width: '15%' }} />
                  <col style={{ width: '15%' }} />
                </colgroup>
                <TableHead>
                  <TableRow>
                    <StyledTableCell >Date</StyledTableCell>
                    <StyledTableCell >Voucher</StyledTableCell>
                    <StyledTableCell >Party & Reference</StyledTableCell>
                    <StyledTableCell >Payment Mode</StyledTableCell>
                    <StyledTableCell style={{textAlign: 'right'}}>Debit</StyledTableCell>
                    <StyledTableCell style={{textAlign: 'right'}}>Credit</StyledTableCell>
                    <StyledTableCell style={{textAlign: 'right'}}>Running Balance</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(ledgerReport && ledgerReport.ledgers && ledgerReport.ledgers.length > 0) ? ledgerReport.ledgers.map((row: any, index: any) =>
                    <>
                      <StyledTableRow key={index}>
                        {/* Combined Date & Voucher Column */}
                        <StyledTableCell>
                          {(row.trxDate && row.trxDate != '') ? (
                            <div style={{ display: 'flex', flexDirection: 'column', lineHeight: '1.5' }}>
                              <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <span style={{ fontWeight: '500', fontSize: '9pt' }}>
                                  {moment(row.trxDate).format("DD MMM YYYY")}
                                </span>
                                <span style={{ fontSize: '8pt', color: '#6b7280', fontStyle: 'italic' }}>
                                  {moment(row.trxDate).format("hh:mm A")}
                                </span>
                              </div>
                              {/* <Chip
                                label={row.voucherType}
                                size="small"
                                style={{
                                  fontSize: '7pt',
                                  height: '18px',
                                  backgroundColor:
                                    row.voucherType === 'Sale Invoice' ? '#3b82f6' :
                                    row.voucherType === 'Purchase Invoice' ? '#dc2626' :
                                    row.voucherType === 'Receipt' ? '#059669' :
                                    row.voucherType === 'Payment' ? '#7c2d12' :
                                    row.voucherType === 'Advance Receipt' ? '#0891b2' :
                                    row.voucherType === 'Advance Payment' ? '#c2410c' :
                                    '#6b7280',
                                  color: 'white'
                                }}
                              /> */}
                            </div>
                          ) : '-'}
                        </StyledTableCell>
                        {/*  Voucher Column */}
                        <StyledTableCell>
                          {(row.trxDate && row.trxDate != '') ? (
                            <div style={{ display: 'flex', flexDirection: 'column', lineHeight: '1.5' }}>
                              <Chip
                                label={row.voucherType}
                                size="small"
                                style={{
                                  fontSize: '7pt',
                                  height: '18px',
                                  backgroundColor:
                                    row.voucherType === 'Sale Invoice' ? '#3b82f6' :
                                    row.voucherType === 'Purchase Invoice' ? '#dc2626' :
                                    row.voucherType === 'Receipt' ? '#059669' :
                                    row.voucherType === 'Payment' ? '#7c2d12' :
                                    row.voucherType === 'Advance Receipt' ? '#0891b2' :
                                    row.voucherType === 'Advance Payment' ? '#c2410c' :
                                    '#6b7280',
                                  color: 'white'
                                }}
                              />
                            </div>
                          ) : '-'}
                        </StyledTableCell>
                        {/* Combined Party & Reference Column */}
                        <StyledTableCell>
                          <div style={{ display: 'flex', flexDirection: 'column', lineHeight: '1.3' }}>
                            <span style={{ fontWeight: '500', fontSize: '9pt' }}>
                              {row.customer}
                            </span>
                            <span style={{ fontSize: '8pt', color: '#374151', fontWeight: '500' }}>
                              #{row.referenceVoucherNumber}
                            </span>
                            {row.invoiceReference && (
                              <span style={{ fontSize: '8pt', color: '#6b7280', fontStyle: 'italic' }}>
                                {row.invoiceReference}
                              </span>
                            )}
                          </div>
                        </StyledTableCell>
                        <StyledTableCell style={{fontStyle: 'italic'}}>{row.paymentMode ? Utils.capitalizeFirstLetter(row.paymentMode.toLowerCase()) : '-'}</StyledTableCell>
                        <StyledTableCell style={{color: row.debit > 0 ? '#d32f2f' : '#757575', textAlign: 'right', fontWeight: row.debit > 0 ? '600' : 'normal'}}>
                          {row.debit > 0 ? `${Utils.formatNumber(parseFloat(row.debit).toFixed(2))}` : ''}
                        </StyledTableCell>
                        <StyledTableCell style={{color: row.credit > 0 ? '#2e7d32' : '#757575', textAlign: 'right', fontWeight: row.credit > 0 ? '600' : 'normal'}}>
                          {row.credit > 0 ? `${Utils.formatNumber(parseFloat(row.credit).toFixed(2))}` : ''}
                        </StyledTableCell>
                        {/* New Running Balance Column */}
                        <StyledTableCell style={{
                          color: row.runningBalance >= 0 ? '#2e7d32' : '#d32f2f', 
                          textAlign: 'right', 
                          fontWeight: 'bold',
                          fontSize: '9pt'
                        }}>
                          {Utils.formatNumber(Math.abs(row.runningBalance || 0).toFixed(2))} {row.runningBalance >= 0 ? 'Dr' : 'Cr'}
                        </StyledTableCell>
                        {/* <StyledTableCell>{Utils.formatNumber(parseFloat(row.balance).toFixed(2) || '0')}</StyledTableCell> */}
                        
                        {/* <StyledTableCell>
                          {row.status == 'DRAFT' && 'Draft'}
                          {row.status == 'PENDING' && 'Pending'}
                          {row.status == 'INVOICED' && 'Invoiced'}
                          {row.status == 'PAID' && 'Paid'}
                          {row.status == 'PARTIALLY_PAID' && 'Partially Paid'}
                          {row.status == 'OVER_PAID' && 'Over Paid'}
                        </StyledTableCell> */}


                      </StyledTableRow>

                    </>
                  ) :
                    <StyledTableRow>
                      <StyledTableCell colSpan={7} style={{textAlign: 'center'}}>No Data Found</StyledTableCell>
                    </StyledTableRow>
                  }
                </TableBody>
              </Table>
              </div>
              </> :
              <>
                <Grid container p={2} >
                  <Grid xs={12} style={{ textAlign: 'center' }}>
                    <CircularProgress color="info"/>
                  </Grid>
                </Grid>
              </>
              }
            </Box>

            {/* Fixed Total Row */}
            {!isLoading && ledgerReport?.ledgerSummary && (
              <Box>
                <Table sx={{ minWidth: 700, tableLayout: 'fixed', width: '100%' }} size='small'>
                  <colgroup>
                  <col style={{ width: '10%' }} />
                  <col style={{ width: '15%' }} />
                  <col style={{ width: '20%' }} />
                  <col style={{ width: '15%' }} />
                  <col style={{ width: '15%' }} />
                  <col style={{ width: '15%' }} />
                  <col style={{ width: '15%' }} />
                </colgroup>
                  <TableBody>
                    <TableRow style={{ backgroundColor: '#f1f5f9' }}>
                      <StyledTableCell style={{
                        fontWeight: 'bold',
                        fontSize: '11pt',
                        backgroundColor: '#f1f5f9',
                        color: '#1e293b',
                        border: '0.75px solid #d9d4d4',
                        borderTop: '2px solid #64748b',
                        padding: 5,
                        paddingLeft: '15px !important'
                      }}>
                        TOTAL
                      </StyledTableCell>
                      <StyledTableCell style={{
                        backgroundColor: '#f1f5f9',
                        border: '0.75px solid #d9d4d4',
                        borderTop: '2px solid #64748b',
                        padding: 5,
                        paddingLeft: '15px !important'
                      }}></StyledTableCell>
                      <StyledTableCell style={{
                        backgroundColor: '#f1f5f9',
                        border: '0.75px solid #d9d4d4',
                        borderTop: '2px solid #64748b',
                        padding: 5,
                        paddingLeft: '15px !important'
                      }}></StyledTableCell>
                      <StyledTableCell style={{
                        backgroundColor: '#f1f5f9',
                        border: '0.75px solid #d9d4d4',
                        borderTop: '2px solid #64748b',
                        padding: 5,
                        paddingLeft: '15px !important'
                      }}></StyledTableCell>
                      <StyledTableCell style={{
                        textAlign: 'right',
                        fontWeight: 'bold',
                        fontSize: '10pt',
                        color: '#dc2626',
                        backgroundColor: '#fee2e2',
                        border: '0.75px solid #d9d4d4',
                        borderTop: '2px solid #64748b',
                        borderLeft: '1px solid #dc2626',
                        borderRight: '1px solid #dc2626',
                        borderBottom: '1px solid #dc2626',
                        padding: 5,
                        paddingLeft: '15px !important',
                        paddingRight: '15px !important'
                      }}>
                        {Utils.formatNumber(parseFloat(ledgerReport.ledgerSummary.totalDebit || 0).toFixed(2))}
                      </StyledTableCell>
                      <StyledTableCell style={{
                        textAlign: 'right',
                        fontWeight: 'bold',
                        fontSize: '10pt',
                        color: '#059669',
                        backgroundColor: '#dcfce7',
                        border: '0.75px solid #d9d4d4',
                        borderTop: '2px solid #64748b',
                        borderLeft: '1px solid #059669',
                        borderRight: '1px solid #059669',
                        borderBottom: '1px solid #059669',
                        padding: 5,
                        paddingLeft: '15px !important',
                        paddingRight: '15px !important'
                      }}>
                        {Utils.formatNumber(parseFloat(ledgerReport.ledgerSummary.totalCredit || 0).toFixed(2))}
                      </StyledTableCell>
                      <StyledTableCell style={{
                        textAlign: 'right',
                        fontWeight: 'bold',
                        fontSize: '10pt',
                        color: ledgerReport.ledgerSummary.netBalance >= 0 ? '#2e7d32' : '#d32f2f',
                        backgroundColor: ledgerReport.ledgerSummary.netBalance >= 0 ? '#dcfce7' : '#fee2e2',
                        border: '0.75px solid #d9d4d4',
                        borderTop: '2px solid #64748b',
                        borderLeft: `1px solid ${ledgerReport.ledgerSummary.netBalance >= 0 ? '#2e7d32' : '#d32f2f'}`,
                        borderRight: `1px solid ${ledgerReport.ledgerSummary.netBalance >= 0 ? '#2e7d32' : '#d32f2f'}`,
                        borderBottom: `1px solid ${ledgerReport.ledgerSummary.netBalance >= 0 ? '#2e7d32' : '#d32f2f'}`,
                        padding: 5,
                        paddingLeft: '15px !important',
                        paddingRight: '15px !important'
                      }}>
                        {Utils.formatNumber(Math.abs(ledgerReport.ledgerSummary.netBalance || 0).toFixed(2))} {ledgerReport.ledgerSummary.netBalance >= 0 ? 'Dr' : 'Cr'}
                      </StyledTableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Box>
            )}
          </Box>

        </Grid>
      </Grid>
    </>
  );
}
export default PartyLedgerReport;